import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
var HTML_TEMPLATE = "\n<div class=\"od-switch\" [ngClass]=\"{'reverse':reverse}\" [attr.disabled]=\"disabled == true ? true : null\"\n\t(click)=\"onClickHandler()\" >\n\t<label class=\"od-switch-label\" [attr.checked]=\"data == true ? true : null\"></label>\n\t<div class=\"od-switch-inner\" [ngClass]=\"{'reverse':reverse}\" >\n\t\t<div *ngIf=\"iconName !=null\" [class]=\"iconName +' od-switch-icon'\"></div>\n\t\t<ion-label>{{_text}}</ion-label>\n\t</div>\n\t<ng-content></ng-content>\n</div>\n";
var CSS_STYLE = "\n.od-switch,\n.od-switch-inner{\n\tdisplay:flex;\n\tflex-direction:row;\n    width: fit-content;\n    align-items: center;\n}\n\n.od-switch,\n.od-switch-inner,\n.od-switch-label:before,\n.od-switch-label:after{\n    cursor:pointer;\n}\n\n.od-switch[disabled]{\n\tpointer-events:none;\n}\n\n.od-switch-label{\n    position: relative;\n\tuser-select: none;\n\tmargin: 6px;\n}\n\n.od-switch-label:before {\n    content: '';\n    border: 1px solid #e4e4e4;\n    background: #d3e6f5;\n    display: block;\n    margin-right: 5px;\n    margin-top: 1px;\n    min-width: 36px;\n    height: 23px;\n    border-radius: 14px;\n    box-shadow: #d3e6f5 0 0 0 0 inset;\n    transition: border .4s,box-shadow .4s;\n}\n\n.od-switch-label[checked]:before{\n\tbackground-color: #64bd63;\n    border-color: #64bd63;\n    box-shadow: #64bd63 0 0 0 16px inset;\n    transition: border .4s,box-shadow .4s,background-color 1.2s;\n}\n\n.od-switch-label[checked]:after {\n    border: solid #fff;\n    border-width: 0 2px 2px 0;\n    transform: rotate(45deg);\n    transition: all .3s;\n}\n\n.od-switch-label:after {\n    content: '';\n    position: absolute;\n    top: 2px;\n    left: 1px;\n    display: block;\n    width: 21px;\n    height: 21px;\n    background-color: white;\n    border-radius: 50px;\n    border: 1px solid #e4e4e4;\n}\n\n.od-switch-label[checked]:after {\n    left:14px;\n}\n\n.od-switch[disabled] .od-switch-label{\n    opacity: .5;\n}\n\n.od-switch.reverse{\n\tflex-direction:row-reverse;\n}\n\n.od-switch-icon{\n    display: flex;\n    align-self: center;\n    width: 26px;\n}\n\n.od-switch-icon:before{\n\tfont-size: 16px;\n    color: #25aed8;\n}\n";
var Switch = /** @class */ (function () {
    function Switch() {
        this.onClick = new EventEmitter();
        this.text = "";
    }
    Object.defineProperty(Switch.prototype, "text", {
        set: function (value) {
            if (value != null)
                this._text = value;
        },
        enumerable: true,
        configurable: true
    });
    Switch.prototype.onClickHandler = function () {
        if (this.onClick != null)
            this.onClick.emit();
        this.data = !this.data;
    };
    Switch.decorators = [
        { type: Component, args: [{
                    selector: 'od-switch',
                    template: HTML_TEMPLATE,
                    styles: [CSS_STYLE]
                },] },
    ];
    /** @nocollapse */
    Switch.ctorParameters = function () { return []; };
    Switch.propDecorators = {
        "data": [{ type: Input },],
        "iconName": [{ type: Input },],
        "reverse": [{ type: Input },],
        "disabled": [{ type: Input },],
        "switch": [{ type: ViewChild, args: ['switch',] },],
        "onClick": [{ type: Output },],
        "text": [{ type: Input },],
    };
    return Switch;
}());
export { Switch };
//# sourceMappingURL=switch.js.map


//////////////////
// WEBPACK FOOTER
// /home/qa/builder/ui-ts/dist/ui-components/check/switch.js
// module id = 425
// module chunks = 14